import React, { Component } from "react";
import { connect } from "react-redux";
import {
  refreshUsersAgents,
  addChatSimult,
  addChat,
  typingadd,
  EfectBlockUser,
  addMonitoring,
  addMonitoringSimult,
  ShowInfoDisplay,
  AlterScreen,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  RequestActiveCallSocketVoz,
  CallConsultaInterna,
  BlockUserInable,
  UserSupDesbloqInable,
  clearConferenceExt,
  addChatSimultIndex,
} from "../actions";
import _ from "lodash";
import axios from "axios";
import TimeCounterInternal from "./TimeCounterInternal";
import Moment from "moment";
import TeamModal from "../modals/TeamModal";
import MicroModal from "micromodal";
import Drawer from "../components/manager-section/Drawer/Drawer";
import { SharedScreen, InitialMonitoring } from "../actions/websocket";
// import { ReactComponent as EMCURSO } from "../build/images/em-curso.svg";
import { ReactComponent as EMCURSO } from "../build/images/teams/monitorias/message-1.svg";
import { ReactComponent as ACCOUNT } from "../build/images/account.svg";
import { ReactComponent as SWITCH } from "../build/images/account-switch.svg";
import { ReactComponent as QUESTION } from "../build/images/question-answer.svg";
import { ReactComponent as FALARATENDENTE } from "../build/images/falar-com-atendente.svg";
// import { ReactComponent as SIGILOSA } from "../build/images/sigilosa.svg";
import { ReactComponent as SIGILOSA } from "../build/images/teams/monitorias/sigilosa.svg";
// import { ReactComponent as SUSSURRO } from "../build/images/sussurro.svg";
import { ReactComponent as SUSSURRO } from "../build/images/teams/monitorias/profile-2user.svg";
import { ReactComponent as MONITORAR } from "../build/images/monitorar.svg";
// import { ReactComponent as INTERCALAR } from "../build/images/intercalar.svg";
import { ReactComponent as INTERCALAR } from "../build/images/teams/monitorias/message.svg";
// import { ReactComponent as BLOQUEIO } from "../build/images/bloqueio.svg";
import { ReactComponent as BLOQUEIO } from "../build/images/teams/monitorias/slash.svg";
import { ReactComponent as PERSON } from "../build/images/outline-person.svg";
import { ReactComponent as OUTLINECALL } from "../build/images/outline-call.svg";
// import { ReactComponent as WHATSAPP } from "../build/images/whatsapp_icon2.svg";
import { ReactComponent as CalendarTeam } from "../build/images/teams/calendar.svg";
import { ReactComponent as HorasLogin } from "../build/images/teams/horas-login.svg";
import { ReactComponent as TempoUltimoStatus } from "../build/images/teams/ultimo-status.svg";
import { ReactComponent as Call } from "../build/images/teams/call.svg";
import { ReactComponent as Search } from "../build/images/teams/search-normal.svg";
import { ReactComponent as Filter } from "../build/images/teams/filter.svg";
import { ReactComponent as QtdTotalIcon } from "../build/images/teams/status-info/profile-2user.svg";
import { ReactComponent as LivresIcon } from "../build/images/teams/status-info/message-search.svg";
import { ReactComponent as PausadosIcon } from "../build/images/teams/status-info/timer-pause.svg";
import { ReactComponent as InteracoesIcon } from "../build/images/teams/status-info/sms-notification.svg";
import { ReactComponent as InativosIcon } from "../build/images/teams/status-info/profile-remove.svg";
import { ReactComponent as ACWIcon } from "../build/images/teams/status-info/warning-2.svg";
import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";
import { ReactComponent as FuturePauseIcon } from "../build/images/pause-circle.svg";
import { ReactComponent as FuturePauseStatic } from "../build/images/pause-static.svg";
import CLIENTE from "../build/images/user.svg";
import FACEBOOK from "../build/images/channelsNew/facebook.svg";
import INSTAGRAM from "../build/images/channelsNew/instagram.svg";
import TELEGRAM from "../build/images/channelsNew/telegram.svg";
import WEBCHAT from "../build/images/channelsNew/webchat.svg";
import WHATSAPP from "../build/images/channelsNew/whatsapp.svg";
import VOZ from "../build/images/channelsNew/voz.svg";
import GOOGLEGBM from "../build/images/channelsNew/googlegbm.svg";
import TEAMS from "../build/images/channelsNew/teamsBig.svg";

// import WHATSAPP from "../build/images/report/whatsapp_icon.svg";
import { Tooltippy, Topover } from "../actions/Tippy";
import ManagerPerfomance from "./ManagerPerfomance";
import ChatSimultComponent from "./ChatSimult";
import UserPhoto from "../components/UserPhoto/userphoto";
import "../build/css/internal-manager.css";
import TimeCounterMinute from "./TimeCounterMinute";
import { AutoSizer, Grid } from "react-virtualized";

const { connection_platform } = require("../services/api");

var gethostname = window.location.hostname;
var pathname = "";

const iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var portims = connection_platform.port_socket_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent =
    connection_platform.ip_extern +
    ":" +
    connection_platform.port_apache_view_extern;
  port = connection_platform.port_backend_extern;
  portims = connection_platform.port_socket_extern;
}

port = localStorage.getItem("port");
pathname = localStorage.getItem("pathname");

const mapDispatchToProps = (dispatch) => {
  return {
    testeeditar: (post, nome) => {
      dispatch(refreshUsersAgents(post, nome));
    },
    clearConference: () => {
      dispatch(clearConferenceExt());
    },
    InitialChat: (iduser, displayname, active, opencall, ramal) => {
      let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
      dispatch(
        addChatSimultIndex(
          iduser,
          displayname,
          active,
          opencall,
          ramal,
          datatime
        )
      );
      // dispatch(
      //   addChatSimult(iduser, displayname, active, opencall, ramal, datatime)
      // );
      // dispatch(addChat(iduser, displayname, active, opencall, ramal, datatime));
      // dispatch(typingadd(iduser, displayname));
    },
    EfectBlockUser: (userout, act, reason) => {
      dispatch(EfectBlockUser(userout, act, reason));
    },
    EditTypeMonitoring: (userout, line) => {
      dispatch(EditTypeMonitorings(userout, line));
      dispatch(EditTypeMonitoringm(userout, line));
      dispatch(ShowInfoDisplay("Monitorias"));
      dispatch(AlterScreen("Monitorias"));
    },
    InitialMonitoring: (userin, userout, name, line, ramal) => {
      dispatch(ShowInfoDisplay("Monitorias"));
      dispatch(AlterScreen("Monitorias"));
      dispatch(addMonitoring(userout, name, line, ramal));
      dispatch(addMonitoringSimult(userout, name, line, ramal));
      if (line != "4") {
        const socket = InitialMonitoring(userin, userout, line, ramal);
      } else {
        const socket = SharedScreen(ramal);
      }
    },
    ConsultaInternaCall: (number, iduser, agents) => {
      dispatch(CallConsultaInterna(number, iduser, agents));
    },
    BlockUserInables: (iduser, reason) => {
      dispatch(BlockUserInable(iduser, reason));
    },
    AlterScreenIn: () => {
      dispatch(ShowInfoDisplay("Monitorias"));
      dispatch(AlterScreen("Monitorias"));
    },
    UserSupDesbloqInable: (reason, idblockdescription, idblocksupervision) => {
      dispatch(
        UserSupDesbloqInable(reason, idblockdescription, idblocksupervision)
      );
    },
    RequestActiveCallSocketVoz: (
      outband,
      infouser,
      trunk,
      mediaid,
      chamado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      callback_count,
      tech,
      idgrupo_rota,
      idgrupo_transb,
      ipcurrent,
      cdrid
    ) => {
      dispatch(
        RequestActiveCallSocketVoz(
          outband,
          infouser,
          trunk,
          mediaid,
          chamado,
          addtech,
          scriptrunk,
          operator,
          returning,
          queueid,
          recvcount,
          callback_count,
          tech,
          idgrupo_rota,
          idgrupo_transb,
          ipcurrent,
          cdrid
        )
      );
    },
  };
};

const mapStateToProps = (state) => {
  return {
    listCallQueue: state.listcallqueue,
    UserGroups: state.groups,
    usersatd: state.agents,
    ChatSimult: state.chatsimult,
    Messages: state.messages,
    InfoUsers: state.informationusers,
    MonitoringSimult: state.monitoringsimult,
    PermissionRouter: state.routergroups,
    OutBandService: state.outservices,
    StatusAgent: state.status,
    IPCurrent: state.ipcurrent,
    ContactId: state.atendimento,
  };
};

class InternalManager extends Component {
  constructor(props) {
    let filtersTotal = [];
    let storageGroup =
      localStorage.getItem("managerinternal_filter_group") || [];
    if (storageGroup.length !== 0) {
      storageGroup = storageGroup.split(",").map(Number);

      filtersTotal = filtersTotal.concat(storageGroup);
    }
    let storageState =
      localStorage.getItem("managerinternal_filter_state") || [];
    if (storageState.length !== 0) {
      storageState = storageState.split(",");

      if (storageState.includes("AT")) {
        const changeArray = storageState.filter(
          (val) => val !== "ATOS" && val !== "CHND" && val !== "RV"
        );
        filtersTotal = filtersTotal.concat(changeArray);
      } else {
        filtersTotal = filtersTotal.concat(storageState);
      }
    }

    // }else{
    //   storageState = ['LV','BQ','ATOS','BQSUPER','AT','RV','CHND']
    // }
    super(props);
    this.state = {
      nameCli: "Cliente",
      groups: [],
      buttonfilter: false,
      act: "1",
      showmodal: false,
      buttonfilter2: false,
      filterGroup: "",
      groupsSelec: [],
      auxkeyGen: [],
      keyGan: storageState,
      auxkeyGan: storageState,
      keyGen: storageGroup,
      actdesb: "1001",
      openDrawer: false,
      totalFilters: filtersTotal,
      textbloqueio: "",
      textdesbloqueio: "",
    };
  }

  changeAgentGroup(e) {
    this.setState({ filterAgent: e.target.value });
  }

  changeGroup(e) {
    this.setState({ filterGroup: e.target.value });
  }

  setVisibleDrawer(bind) {
    bind.setState({ openDrawer: false });
    bind.setState({ buttonfilter: false });
    bind.setState({ buttonfilter2: false });
  }

  filterGroup(e, idgroup, description) {
    let filtersgroupstorage = [];
    if (e.target.checked) {
      this.setState({
        keyGen: this.state.keyGen.concat([idgroup]),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.concat([idgroup]),
      });
      this.setState({
        totalFilters: this.state.totalFilters.concat([idgroup]),
      });
      filtersgroupstorage = this.state.keyGen.concat([idgroup]);
    } else {
      this.setState({
        keyGen: this.state.keyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      this.setState({
        totalFilters: this.state.totalFilters.filter(function (val) {
          return val != idgroup;
        }),
      });
      this.RemoveGroupSelec(e, idgroup);
      filtersgroupstorage = this.state.keyGen.filter(function (val) {
        return val != idgroup;
      });
    }
    localStorage.setItem("managerinternal_filter_group", filtersgroupstorage);
  }

  filterState(e, status) {
    let filterstatestorage = [];
    if (e.target.checked) {
      filterstatestorage = this.state.keyGan.concat([status]);
      if (status === "AT") {
        filterstatestorage = filterstatestorage.concat(["ATOS"]);
        filterstatestorage = filterstatestorage.concat(["CHND"]);
        filterstatestorage = filterstatestorage.concat(["RV"]);
      }
      this.setState({
        keyGan: filterstatestorage,
      });
      this.setState({
        auxkeyGan: filterstatestorage,
      });
      this.setState({ totalFilters: this.state.totalFilters.concat([status]) });
    } else {
      filterstatestorage = this.state.keyGan.filter(function (val) {
        return val != status;
      });
      if (status === "AT") {
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "ATOS";
        });
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "CHND";
        });
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "RV";
        });
      }
      this.setState({
        keyGan: filterstatestorage,
      });
      this.setState({
        auxkeyGan: filterstatestorage,
      });
      this.setState({
        totalFilters: this.state.totalFilters.filter(function (val) {
          return val != status;
        }),
      });
    }
    localStorage.setItem("managerinternal_filter_state", filterstatestorage);
  }

  ShowFilters(e) {
    e.preventDefault();
    this.setState({ buttonfilter: !this.state.buttonfilter });
  }

  ShowFilters2(e) {
    e.preventDefault();
    this.setState({ buttonfilter2: !this.state.buttonfilter2 });
  }

  RemoveStateSelec(e, id) {
    e.stopPropagation();
    document.getElementById("checkbox-" + id).click();
  }

  RemoveGroupSelec(e, id) {
    e.stopPropagation();
    document.getElementById("checkbox-geral" + id).click();
  }

  RemoveAllGroup(e) {
    let array = this.state.groupsSelec;
    for (let i = 0; i < array.length; i++) {
      var myCheckbox = document.getElementById("checkbox-geral" + array[i].id);
      myCheckbox.checked = false;
    }
    this.setState({ keyGen: [], auxkeyGen: [] });
    localStorage.setItem("managerinternal_filter_group", []);
  }

  RemoveAllState(e) {
    let array = this.state.keyGan.filter(
      (val) => val !== "ATOS" && val !== "CHND" && val !== "RV"
    );
    for (let i = 0; i < array.length; i++) {
      var myCheckbox = document.getElementById("checkbox-" + array[i]);
      myCheckbox.checked = false;
    }
    this.setState({ keyGan: [], auxkeyGan: [] });
    localStorage.setItem("managerinternal_filter_state", []);
  }

  showModal(e, userout, action, reasonaction, duration, status) {
    if (action === "BQSUPER") {
      MicroModal.show("modal__desbloqueio");
      duration = duration.split(" ");
      let horaaction = duration[1].split("-");
      horaaction = horaaction[0];
      duration = duration[0];
      this.setState({
        userout: userout,
        horaaction: horaaction,
        duration: duration,
        reasonaction: reasonaction,
        act: "1001",
        actdesb: "1001",
        inable: false,
      });
    } else {
      if (status !== null) {
        MicroModal.show("modal__bloqueio");
        this.setState({
          userout: userout,
          act: this.state.act,
          inable: false,
          //act: "1",
        });
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblock?iduser=${userout}`
          )
          .then((response) => {
            if (response.data.durationblock === 0) {
              var idreturnblockdescription = response.data.id;
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblocksup?iduser=${userout}`
                )
                .then((response) => {
                  MicroModal.show("modal__desbloqueio");
                  this.setState({ inable: true });
                  duration = response.data.blockingdate.split("T");
                  let horaaction = duration[1].split("-");
                  horaaction = horaaction[0];
                  duration = duration[0];
                  duration = Moment(duration, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                  );
                  this.setState({
                    userout: userout,
                    horaaction: horaaction,
                    duration: duration,
                    reasonaction: response.data.blockingreason,
                    idblock: idreturnblockdescription,
                    idsup: response.data.id,
                  });
                })
                .catch((error) => {
                  console.log("trycatch");
                });
            } else {
              this.setState({
                userout: userout,
                act: this.state.act,
                inable: true,
              });
              MicroModal.show("modal__bloqueio");
            }
          })
          .catch((error) => {
            console.log("trycatch");
          });
      }
    }
  }

  ActionUserSup(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input").value;
    let reason = this.state.textbloqueio;
    this.props.EfectBlockUser(this.state.userout, this.state.act, reason);
    this.setState({ act: "1" });
    MicroModal.close(modal);
  }

  ActionBlockUserInable(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input").value;
    let reason = this.state.textbloqueio;
    this.props.BlockUserInables(this.state.userout, reason);
    MicroModal.close(modal);
  }

  InitialChat(e, chatsimult, user) {
    this.props.InitialChat(
      parseInt(user.iduser),
      user.label,
      true,
      false,
      user.ramal
    );

    // let erro = 0;
    // if (chatsimult.length != 0) {
    //   chatsimult.map((chat) => {
    //     if (parseInt(chat.iduserout) === parseInt(user.iduser)) {
    //       erro = 1;
    //     } else if (erro != 1) {
    //       erro = 0;
    //     }
    //   });
    //   if (erro === 1) {
    //     console.log("JA POSSUI CHAT ATIVO");
    //   } else {
    //     this.props.InitialChat(
    //       parseInt(user.iduser),
    //       user.label,
    //       true,
    //       false,
    //       user.ramal
    //     );
    //   }
    // } else {
    //   this.props.InitialChat(
    //     parseInt(user.iduser),
    //     user.label,
    //     true,
    //     false,
    //     user.ramal
    //   );
    // }
  }

  InitialCall(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    status,
    queue,
    ramal,
    ipcurrent,
    chatsimult,
    user
  ) {
    let erro = 0;

    // checkAnswerInitial = getState().ChatSimult;

    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === false
        ) {
          erro = 1;
        } else if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === true
        ) {
          erro = 2;
        } else if (erro != 1 || erro != 2) {
          erro = 0;
        }
      });
      if (erro === 1) {
        this.props.clearConference();
        this.props.ConsultaInternaCall(user.ramal, user.iduser, user);
      } else if (erro === 2) {
        console.log("JA POSSUI CHAT ATIVO COM VOZ");
      } else {
        this.props.InitialChat(
          parseInt(user.iduser),
          user.label,
          true,
          true,
          user.ramal
        );
        this.props.ConsultaInternaCall(user.ramal, user.iduser, user);
      }
    } else {
      this.props.InitialChat(
        parseInt(user.iduser),
        user.label,
        true,
        true,
        user.ramal
      );
      this.props.ConsultaInternaCall(user.ramal, user.iduser, user);
    }
  }

  InitialMonitoring(e, userin, userout, name, monitoringsimult, line, ramal) {
    let erro = 0;
    let auxline;

    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          this.props.EditTypeMonitoring(userout, line);
        }
      } else {
        this.props.InitialMonitoring(userin, userout, name, line, ramal);
      }
    } else {
      this.props.InitialMonitoring(userin, userout, name, line, ramal);
    }
    this.props.AlterScreenIn();
  }

  ActionUserSupDesbloq(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input-desb").value;
    let reason = this.state.textdesbloqueio;
    this.props.EfectBlockUser(this.state.userout, this.state.act, reason);
    this.setState({ act: "1" });
    MicroModal.close(modal);
  }

  ActionUserSupDesbloqInable(e, modal) {
    //let reason = document.getElementById("anotc-add__textarea__input-desb").value;
    let reason = this.state.textdesbloqueio;
    this.props.UserSupDesbloqInable(
      reason,
      this.state.idblock,
      this.state.idsup
    );
    MicroModal.close(modal);
  }

  AlterBlockAction(e, value) {
    this.setState({ act: value });

    if (value === "1") {
      document.getElementById("logout-atd").checked = false;
    } else {
      document.getElementById("block-atd").checked = false;
    }
  }

  AlterBlockActionDesb(e, value) {
    this.setState({ actdesb: value });
    if (value === "1001") {
      document.getElementById("radio-22").checked = false;
    } else {
      document.getElementById("radio-11").checked = false;
    }
  }

  ShowTeamModal() {
    MicroModal.show("modal__mensagem-equipe");
  }

  renderPopoverInfo = (e, number, contact) => (
    <div className=" context-menu" id="drop-info-contact">
      <ul className="context-menu__list">
        <li className="contact-info">
          <PERSON />
          <div className="contact-info__name">
            {contact === -1 ? number : contact}
          </div>
        </li>

        <li className="contact-info">
          <OUTLINECALL />
          <div className="contact-info__name">{number}</div>
        </li>
      </ul>
    </div>
  );

  SolicitarChamadaAtiva(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    status,
    queue,
    ramal,
    ipcurrent,
    statusAgent
  ) {
    if (this.props.ContactId.length !== 0) {
      localStorage.setItem(
        "current-service",
        this.props.ContactId.idatendimento
      );
    }

    if (statusAgent.allowCall === false) {
      this.props.InterationNotifier("Pausa não permite ativo", "permission");
      return true;
    }

    var existeRota = false;
    var rotaDefault = false;
    var rotaAlternativa = false;
    var trunk = "";
    var addtech = "";
    var scriptrunk = "";
    var operator = "";
    var trunkDef = "";
    var addtechDef = "";
    var scriptrunkDef = "";
    var operatorDef = "";
    var tech = "";
    var techDef = "";
    var idgrupo_rota = "";
    var idgrupo_rotaDef = "";
    var idgrupo_transb = "";
    var idgrupo_transbDef = "";
    var chamado = ramal;
    var retorno = 0;
    var queueid;
    var recvcount;

    chamado = chamado.replace(/\D/g, "");

    var DDD = "71";

    if (chamado != "") {
      if (!isNaN(chamado)) {
        permrouter.map((result) => {
          if (parseInt(result.idmidia) === parseInt(mediaid)) {
            existeRota = true;

            if (result.isdefault == "t") {
              rotaDefault = true;
              trunkDef = result.idtrunk;
              addtechDef = result.addtech;
              scriptrunkDef = result.scripttrunk;
              operatorDef = result.operator;
              techDef = result.tech;
              idgrupo_rotaDef = result.idgrupo_rota;
              idgrupo_transbDef = result.idgrupo_transb;
            }

            if (parseInt(result.areacode) == parseInt(DDD)) {
              rotaAlternativa = true;
              trunk = result.idtrunk;
              addtech = result.addtech;
              scriptrunk = result.scripttrunk;
              operator = result.operator;
              tech = result.tech;
              idgrupo_rota = result.idgrupo_rota;
              idgrupo_transb = result.idgrupo_transb;
            } else {
              if (result.calltypeid == 3 || result.calltypeid == 4) {
                rotaAlternativa = true;
                trunk = result.idtrunk;
                addtech = result.addtech;
                scriptrunk = result.scripttrunk;
                operator = result.operator;
                tech = result.tech;
                idgrupo_rota = result.idgrupo_rota;
                idgrupo_transb = result.idgrupo_transb;
              }
            }
          }
        });

        if (rotaDefault == true && rotaAlternativa == false) {
          trunk = trunkDef;
          addtech = addtechDef;
          scriptrunk = scriptrunkDef;
          operator = operatorDef;
        }

        if (mediaid == 1)
          this.props.RequestActiveCallSocketVoz(
            outband,
            infouser,
            trunk,
            mediaid,
            chamado,
            addtech,
            scriptrunk,
            operator,
            true,
            queueid,
            recvcount,
            null,
            tech,
            idgrupo_rota,
            idgrupo_transb,
            ipcurrent
          );
      }
    }
  }

  renderIconInfo(user) {
    if (
      user.status_sip === "LV" &&
      user.status === "AT" &&
      user.status_sip !== "QAT"
    ) {
      return (
        <div className="card__content__status-info-item">
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} alt="Ícone do Telefone" />
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} alt="Ícone do Facebook" />
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPP} alt="Ícone do Whatsapp" />
                </>
              );
            } else if (user.mediaid === "6" || user.mediaid === 6) {
              return (
                <>
                  <img src={INSTAGRAM} alt="Ícone do Instagram" />
                </>
              );
            } else if (user.mediaid === "8" || user.mediaid === 8) {
              return (
                <>
                  <img src={TELEGRAM} alt="Ícone do Telegram" />
                </>
              );
            } else if (user.mediaid === "2" || user.mediaid === 2) {
              return (
                <>
                  <img src={WEBCHAT} alt="Ícone do Webchat" />
                </>
              );
            } else if (user.mediaid === "11" || user.mediaid === 11) {
              return (
                <>
                  <img src={GOOGLEGBM} alt="Ícone do Google GBM" />
                </>
              );
            } else if (user.mediaid === "15" || user.mediaid === 15) {
              return (
                <>
                  <img src={TEAMS} alt="Ícone do teams" />
                </>
              );
            } else {
              return (
                <>{/* <i className="material-icons">phone_in_talk</i> */}</>
              );
            }
          })()}
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Atendimento
          </div>
        </div>
      );
    } else if (
      (user.status_sip === "AT" && user.status === "AT") ||
      (user.status_sip === "RV" && user.status === "ATOS")
    ) {
      return (
        <div className="card__content__status-info-item">
          {(() => {
            if (user.mediaid === "1") {
              return (
                <div>
                  <img src={VOZ} alt="Ícone do Telefone" />
                </div>
              );
            } else if (user.mediaid === "4") {
              return (
                <div>
                  <img src={FACEBOOK} alt="Ícone do Facebook" />
                </div>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <div>
                  <img src={WHATSAPP} alt="Ícone do Whatsapp" />
                </div>
              );
            } else if (user.mediaid === "15" || user.mediaid === 15) {
              return (
                <div>
                  <img src={TEAMS} alt="Ícone do teams" />
                </div>
              );
            } else {
              // return <i className="material-icons">phone_in_talk</i>;
              return <></>;
            }
          })()}
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Atendimento
          </div>
        </div>
      );
    } else if (user.status_sip === "QAT") {
      return (
        <Tooltippy content={user.direcao}>
          <div className="card__content__status-info-item">
            <div className="pausa-content pausa-btn--chmd-consulta">
              <div className="background-tick "></div>
              Em consulta
            </div>
          </div>
        </Tooltippy>
      );
    } else if (
      (user.status_sip === "AT" && user.status === "ATOS") ||
      (user.status_sip === "ATOS" && user.status === "AT")
    ) {
      return (
        <div className="card__content__status-info-item">
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} alt="Ícone do Telefone" />
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} alt="Ícone do Facebook" />
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPP} alt="Ícone do Whatsapp" />
                </>
              );
            } else if (user.mediaid === "15" || user.mediaid === 15) {
              return (
                <>
                  <img src={TEAMS} alt="Ícone do Teams" />
                </>
              );
            } else {
              return (
                <>{/* <i className="material-icons">phone_in_talk</i> */}</>
              );
            }
          })()}
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Atendimento
          </div>
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <div className="card__content__status-info-item">
          <i className="material-icons">phone_in_talk</i>
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Discando
          </div>
        </div>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND") {
      return (
        <div className="card__content__status-info-item">
          <i className="material-icons">phone_in_talk</i>
          <div className="pausa-content pausa-btn--chmd-ativa">
            <div className="background-tick "></div>
            Chamando
          </div>
        </div>
      );
    } else if (user.status_sip === "BQ" && user.razao_bloqueio != "") {
      return (
        <div className="card__content__status-info-item">
          <div className="pausa-content pausa-btn--pausado">
            <div className="background-tick "></div>
            Pausado
          </div>
        </div>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div className="card__content__status-info-item">
          {(() => {
            if (user.mediaid === "1") {
              return (
                <>
                  <img src={VOZ} alt="Ícone do Telefone" />
                </>
              );
            } else if (user.mediaid === "4") {
              return (
                <>
                  <img src={FACEBOOK} alt="Ícone do Facebook" />
                </>
              );
            } else if (user.mediaid === "5" || user.mediaid === 5) {
              return (
                <>
                  <img src={WHATSAPP} alt="Ícone do Whatsapp" />
                </>
              );
            } else if (user.mediaid === "15" || user.mediaid === 15) {
              return (
                <>
                  <img src={TEAMS} alt="Ícone do Teams" />
                </>
              );
            } else {
              return (
                <>
                  <i className="material-icons">perm_phone_msg</i>
                </>
              );
            }
          })()}
          <div className="pausa-content pausa-btn--after-call">
            <div className="background-tick "></div>
            AfterCallWork
          </div>
        </div>
      );
    } else if (
      user.status_sip === null ||
      user.status === null ||
      user.status_sip === "null" ||
      user.status === "null"
    ) {
      return (
        <div className="card__content__status-info-item">
          <div className="pausa-content pausa-btn--inativo">
            <div className="background-tick "></div>
            Inativo
          </div>
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "LV") {
      return (
        <div className="card__content__status-info-item">
          <div className="pausa-content pausa-btn--livre">
            <div className="background-tick "></div>
            Livre
          </div>
        </div>
      );
    } else if (user.status_sip === "RV" && user.status === "LV") {
      return (
        <div className="card__content__status-info-item ">
          <div className="pausa-content pausa-btn--livre">
            <div className="background-tick "></div>
            Livre
          </div>
        </div>
      );
    } else if (user.status_sip === "BQSUPER" && user.status === "BQSUPER") {
      return (
        <div className="card__content__status-info-item">
          <i className="material-icons">phone_paused</i>
          <div className="pausa-content pausa-btn--pausado">
            <div className="background-tick "></div>
            Bloqueado
          </div>
        </div>
      );
    }
  }

  renderNumbInfo(user) {
    if (
      user.status_sip === "LV" &&
      user.status === "AT" &&
      user.status_sip !== "QAT"
    ) {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                (user.speaknum && user.speaknum.length > 11) ||
                (user.razao_bloqueio && user.razao_bloqueio.length > 11)
                  ? "w-min"
                  : ""
              }`}
            >
              {user.speaknum || user.razao_bloqueio}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "QAT") {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                (user.speaknum && user.speaknum.length > 11) ||
                (user.razao_bloqueio && user.razao_bloqueio.length > 11)
                  ? "w-min"
                  : ""
              }`}
            >
              {user.speaknum || user.razao_bloqueio}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "RV" && user.status === "ATOS") {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio != "CHND") {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div
          className="card__content__number tippy-default"
          data-tippy-placement="top"
        >
          <Call />
          <div
            className={`card__content__number-number ${
              user.razao_bloqueio && user.razao_bloqueio.length > 11
                ? "w-min"
                : ""
            }`}
          >
            {user.razao_bloqueio}
          </div>
        </div>
      );
      // } else if (user.status_sip === "BQ" && user.razao_bloqueio != "") {
      //   return (
      //     <div
      //       className="card__content__number tippy-default"
      //       data-tippy-placement="top"
      //       data-tippy-content="Maria Bernandes Dourado"
      //     >
      //       {user.razao_bloqueio}
      //     </div>
      //   );
    } else if (user.status_sip === "ACW" && user.status != "ACW") {
      return (
        <div
          className="card__content__number tippy-default"
          data-tippy-placement="top"
        >
          AfterCallWork
        </div>
      );
    } else if (user.status_sip === "AT" && user.status === "AT") {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                (user.speaknum && user.speaknum.length > 11) ||
                (user.razao_bloqueio && user.razao_bloqueio.length > 11)
                  ? "w-min"
                  : ""
              }`}
            >
              {user.speaknum || user.razao_bloqueio}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "ATOS" && user.status === "AT") {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    } else if (user.status_sip === "AT" && user.status === "ATOS") {
      return (
        <Topover
          interactive={true}
          content={this.renderPopoverInfo(
            this,
            user.speaknum,
            user.razao_bloqueio
          )}
        >
          <div
            className="card__content__number tippy-default"
            data-tippy-placement="top"
          >
            <Call />
            <div
              className={`card__content__number-number ${
                user.speaknum && user.speaknum.length > 11 ? "w-min" : ""
              }`}
            >
              {user.speaknum}
            </div>
          </div>
        </Topover>
      );
    }
  }

  timeFuturePause(user, IPCurrent) {
    let duracaoFPause = "";
    let datatimeCompA = Moment().format("YYYY/MM/DD HH:mm:ss");
    const hasDuration =
      !!user &&
      !!user.duration &&
      typeof user.duration === "string" &&
      user.duration.includes("-") &&
      user.duration.split("-").length > 0;
    let arrayCompA = hasDuration ? user.duration.split("-") : [datatimeCompA];
    let dataStatusA = Moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
      "YYYY/MM/DD HH:mm:ss"
    );

    var valorDiferenca = parseInt(Math.abs(Math.round(IPCurrent.difftime)));

    if (parseInt(IPCurrent.difftime) < 0) {
      datatimeCompA = Moment()
        .subtract(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    } else {
      datatimeCompA = Moment()
        .add(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }

    duracaoFPause = Moment(datatimeCompA).diff(dataStatusA, "seconds");
    duracaoFPause = duracaoFPause < 0 ? 0 : duracaoFPause;

    return (
      <div style={{ minWidth: "65px" }}>
        <TimeCounterMinute
          horario={parseInt(duracaoFPause)}
          key={user.iduser + user.status + user.tmfuturepause}
        />
      </div>
    );
  }

  timeLastStatus(user, IPCurrent) {
    let duracao = "";
    if (user.duration != null) {
      let arrayCompA = user.duration.split("-");
      let datatimeCompA = Moment().format("YYYY/MM/DD HH:mm:ss");
      //var valorDiferenca = parseInt(Math.abs(Math.round(IPCurrent.difftime)));

      var valorDiferenca = datatimeCompA;

      if (parseInt(IPCurrent.difftime) < 0) {
        datatimeCompA = Moment()
          .subtract(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        datatimeCompA = Moment()
          .add(valorDiferenca, "seconds")
          .format("YYYY/MM/DD HH:mm:ss");
      }

      // let dataStatusA = Moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
      //   "YYYY/MM/DD HH:mm:ss"
      // );

      // let dataStatusA = Moment(arrayCompA[0], "YYYY/MM/DD HH:mm:ss").format(
      //   "YYYY/MM/DD HH:mm:ss"
      // );

      let dataStatusA = Moment(arrayCompA[0], "DD/MM/YYYY HH:mm:ss").format(
        "YYYY/MM/DD HH:mm:ss"
      );

      duracao = Moment(valorDiferenca).diff(dataStatusA, "seconds");
      duracao = duracao < 0 ? 0 : duracao;
    }

    if (
      user.status_sip === "LV" &&
      user.status === "AT" &&
      user.status_sip !== "QAT"
    ) {
      return (
        <div
          className="card__content__info__item"
          key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
          />
        </div>
      );
    }
    if (user.status_sip === "QAT") {
      return (
        <div
          className="card__content__info__item"
          key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={"intmng" + user.value + "_" + user.status_sip + user.speaknum}
          />
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "RV") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            Math.floor(Math.random() * 1000000)
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          />
        </div>
      );
    } else if (user.status_sip === "RV" && user.status === "ATOS") {
      return (
        <div>
          <div
            style={{ display: "none" }}
            className="pausa-content pausa-btn--inativo"
          >
            <i className="material-icons">phone_locked</i>
            Inativo
          </div>
          <div
            className="card__content__info__item"
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          >
            <TempoUltimoStatus />
            <TimeCounterInternal
              horario={parseInt(duracao)}
              key={
                "intmng" +
                user.value +
                "_" +
                user.status_sip +
                "_" +
                Math.floor(Math.random() * 1000000)
              }
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "AT" && user.razao_bloqueio !== "AT") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            Math.floor(Math.random() * 1000000)
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          />
        </div>
      );
    } else if (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            Math.floor(Math.random() * 1000000)
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          />
        </div>
      );
    } else if (user.status_sip === "ACW" && user.status === "ACW") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            Math.floor(Math.random() * 1000000)
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          />
        </div>
      );
    } else if (user.status_sip === "BQ" && user.razao_bloqueio != "") {
      return (
        <div
          className="card__content__info__item"
          key={
            "intmng" +
            user.value +
            "_" +
            user.status_sip +
            "_" +
            Math.floor(Math.random() * 1000000)
          }
        >
          <TempoUltimoStatus />
          <TimeCounterInternal
            horario={parseInt(duracao)}
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          />
        </div>
      );
    } else if (user.status_sip === "LV" && user.status === "LV") {
      return (
        <div>
          <div
            style={{ display: "none" }}
            className="pausa-content pausa-btn--pausado"
          >
            <i className="material-icons">phone_paused</i>
            Pausa
          </div>
          <div
            className="card__content__info__item"
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          >
            <TempoUltimoStatus />
            <TimeCounterInternal
              horario={parseInt(duracao)}
              key={
                "intmng" +
                user.value +
                "_" +
                user.status_sip +
                "_" +
                Math.floor(Math.random() * 1000000)
              }
            />
          </div>
        </div>
      );
    } else if (user.status_sip === "BQSUPER" && user.status === "BQSUPER") {
      return (
        <div>
          <div
            style={{ display: "none" }}
            className="pausa-content pausa-btn--pausado"
          >
            <i className="material-icons">phone_paused</i>
            Bloqueado
          </div>
          <div
            className="card__content__info__item"
            key={
              "intmng" +
              user.value +
              "_" +
              user.status_sip +
              "_" +
              Math.floor(Math.random() * 1000000)
            }
          >
            <TempoUltimoStatus />
            <TimeCounterInternal
              horario={parseInt(duracao)}
              key={
                "intmng" +
                user.value +
                "_" +
                user.status_sip +
                "_" +
                Math.floor(Math.random() * 1000000)
              }
            />
          </div>
        </div>
      );
    }
  }

  render() {
    const {
      UserGroups,
      usersatd,
      ChatSimult,
      Messages,
      InfoUsers,
      MonitoringSimult,
      PermissionRouter,
      OutBandService,
      StatusAgent,
      listCallQueue,
      IPCurrent,
    } = this.props;

    this.datalogin = Moment().format("DD/MM/YYYY");
    this.horalogin = Moment().format("HH:MM");

    if (UserGroups.length != 0) {
      this.state.groups = UserGroups.groups;
    } else {
      this.state.grupos = [];
    }

    if (usersatd.length != 0) {
      this.state.lsusersatd = usersatd;
      if (this.state.keyGen.length > 0) {
        this.state.lsusersatd = this.state.lsusersatd.filter((agent) =>
          this.state.keyGen.includes(agent.id_grupo)
        );
      }
      if (this.state.keyGan.length > 0) {
        // this.state.lsusersatd = this.state.lsusersatd.filter(
        //   (agent) =>
        //     this.state.keyGan.includes(agent.status) ||
        //     this.state.keyGan.includes(agent.status_sip)
        // );
        this.state.lsusersatd = this.state.lsusersatd.filter((agent) =>
          this.state.keyGan.includes(agent.status, agent.status_sip)
        );
        // this.state.lsusersatd = this.state.lsusersatd.filter(agent => this.state.keyGan.includes(agent.status_sip))
      }
    } else {
      this.state.lsusersatd = [];
    }

    const list = this.state.lsusersatd || [];
    this.state.lsusersatd = _.filter(list, (agent) => {
      let arrayAgent = [
        agent.username,
        agent.desc_grupo,
        agent.ramal,
        agent.razao_bloqueio,
      ];
      return !_.isEmpty(this.state.filterAgent)
        ? arrayAgent
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterAgent.toString().toLowerCase()) > -1
        : true;
    });

    this.state.lsusersatd = _.orderBy(
      this.state.lsusersatd,
      ["label"],
      ["asc"]
    );

    const listin = this.state.groups || [];
    this.state.groups = _.filter(listin, (group) => {
      let arrayGroup = [group.name];
      return !_.isEmpty(this.state.filterGroup)
        ? arrayGroup
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterGroup.toString().toLowerCase()) > -1
        : true;
    });

    this.state.groupsSelec = this.state.groups.filter((gs) =>
      this.state.keyGen.includes(gs.id)
    );

    const agentesLivres = this.state.lsusersatd.filter(
      (user) =>
        (user.status_sip === "RV" && user.status === "LV") ||
        (user.status_sip === "LV" && user.status === "LV")
    );
    const agentesPausados = this.state.lsusersatd.filter((user) => {
      return user.status_sip === "BQ" && user.razao_bloqueio !== "";
    });
    const agentesAtendendo = this.state.lsusersatd.filter(
      (user) =>
        (user.status_sip === "LV" && user.status === "AT") ||
        (user.status_sip === "AT" && user.status === "AT") ||
        (user.status_sip === "RV" && user.status === "ATOS") ||
        (user.status_sip === "AT" && user.status === "ATOS") ||
        (user.status_sip === "ATOS" && user.status === "AT") ||
        (user.status_sip === "LV" && user.status === "RV") ||
        (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND")
    );
    const agentesInativos = this.state.lsusersatd.filter(
      (user) =>
        user.status_sip === null ||
        user.status === null ||
        user.status_sip === "null" ||
        user.status === "null"
    );
    const agentesACW = this.state.lsusersatd.filter(
      (user) => user.status_sip === "ACW" && user.status === "ACW"
    );

    return (
      <div className="canvas__wrapper">
        <div className="canvas__wrapper__body equipe-page">
          <div className="column-model--overflow w-auto atendente-gestor new-internal-manager-no-overflow">
            <div className="column-model__body">
              <div className="column-model__body__block">
                <div className="box">
                  <div className="box__title">Equipes</div>

                  <div className="box__body">
                    <div className="card card--med">
                      <div className="full-search">
                        <input
                          type="text"
                          name="client-search"
                          id="client-search"
                          placeholder="Pesquisar atendente"
                          onChange={(event) => this.changeAgentGroup(event, "")}
                        />
                        <button type="submit" className="full-search__btn">
                          {/* <i className="material-icons">search</i> */}
                          <Search />
                        </button>
                      </div>

                      <div className="actions">
                        <div
                          className="actions__item"
                          onClick={(event) =>
                            this.setState({ openDrawer: true })
                          }
                        >
                          <Filter />
                          <span>Filtros</span>
                          {this.state.totalFilters.length > 0 && (
                            <span className="total-filters">
                              {this.state.totalFilters.length}
                            </span>
                          )}
                        </div>
                        {/* <div className="actions__item tippy-default" data-tippy="Conferência de grupo">
                                      <Tooltippy content={'Conferência de grupo'}><a><ACCOUNT /></a></Tooltippy>
                                      </div>
                                      <div className="actions__item tippy-default" data-tippy="Transferência de grupo">
                                      <Tooltippy content={'Transferência de grupo'}><a><SWITCH /></a></Tooltippy>
                                      </div> */}
                        <div
                          className="actions__item secundary_item tippy-default"
                          onClick={(event) => this.ShowTeamModal(event)}
                          data-tippy="Chat de grupo"
                        >
                          <Tooltippy content={"Chat de grupo"}>
                            <EMCURSO />
                            <span>Mensagem</span>
                          </Tooltippy>
                        </div>
                      </div>
                    </div>

                    {/* {(() => {
                      if (this.state.groupsSelec.length != 0) {
                        return (
                          <div
                            className={
                              this.state.buttonfilter
                                ? "box__body__filter-content active"
                                : "box__body__filter-content"
                            }
                          >
                            <div className="card-preview card-preview--close-all">
                              <div
                                className="card-preview--close-all__icon"
                                onClick={(event) => this.RemoveAllGroup(event)}
                              >
                                <i className="material-icons">close</i>
                              </div>
                              <div
                                className="card-preview--close-all__text"
                                onClick={(event) => this.RemoveAllGroup(event)}
                              >
                                Fechar todos
                              </div>
                            </div>
                            {this.state.groupsSelec.map((gs, index) => (
                              <div className="card-preview" key={index}>
                                <div
                                  className="card-preview__text"
                                  onClick={(event) =>
                                    this.RemoveGroupSelec(event, gs.id)
                                  }
                                >
                                  {gs.name}
                                </div>
                                <div className="card-preview__icon">
                                  <i
                                    onClick={(event) =>
                                      this.RemoveGroupSelec(event, gs.id)
                                    }
                                    className="material-icons"
                                  >
                                    close
                                  </i>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      }
                    })()} */}
                  </div>

                  <div className="box__body-footer">
                    <div className="status__info-box">
                      <div className="icon">
                        <QtdTotalIcon />
                      </div>
                      <div className="info">
                        <span>Qtd. total:</span> {this.state.lsusersatd.length}
                      </div>
                    </div>
                    <div className="status__info-box">
                      <div className="icon">
                        <LivresIcon />
                      </div>
                      <div className="info">
                        <span>Livres:</span> {agentesLivres.length}
                      </div>
                    </div>
                    <div className="status__info-box">
                      <div className="icon">
                        <PausadosIcon />
                      </div>
                      <div className="info">
                        <span>Pausados:</span> {agentesPausados.length}
                      </div>
                    </div>
                    <div className="status__info-box">
                      <div className="icon">
                        <InteracoesIcon />
                      </div>
                      <div className="info">
                        <span>Atendimentos:</span> {agentesAtendendo.length}
                      </div>
                    </div>
                    <div className="status__info-box">
                      <div className="icon">
                        <InativosIcon />
                      </div>
                      <div className="info">
                        <span>Inativo:</span> {agentesInativos.length}
                      </div>
                    </div>
                    <div className="status__info-box">
                      <div className="icon">
                        <ACWIcon />
                      </div>
                      <div className="info">
                        <span>ACW:</span> {agentesACW.length}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    flex: 1,
                    width: "100%",
                    height: "calc(100% - 10px)",
                  }}
                >
                  <AutoSizer>
                    {({ height, width }) => {
                      const cellMinWidth = 200; // Largura mínima da célula
                      const cellMaxWidth = 260; // Largura máxima da célula
                      const gap = 10; // Espaçamento entre colunas e linhas
                      const columnWidth = Math.min(
                        cellMaxWidth,
                        Math.max(cellMinWidth, width)
                      );
                      const cellHeight = 220; // Altura fixa do card

                      // Calcula o número de colunas baseado na largura disponível
                      const columnCount = Math.max(
                        1,
                        Math.floor((width + gap) / (columnWidth + gap)) // Número de colunas
                      );

                      // Calcula o número de linhas baseado no total de itens
                      const rowCount = Math.ceil(
                        this.state.lsusersatd.length / columnCount
                      );

                      const cellRenderer = ({
                        columnIndex,
                        key,
                        rowIndex,
                        style,
                      }) => {
                        const index = rowIndex * columnCount + columnIndex;
                        if (index >= this.state.lsusersatd.length) return null;

                        const user = this.state.lsusersatd[index];

                        return (
                          <div
                            key={key}
                            className="internal-manager-ondemand-card"
                            style={{
                              ...style,
                              flex: 1,
                              padding: `${gap / 2}px`,
                            }}
                          >
                            <CardUser
                              key={index}
                              user={user}
                              bind={this}
                              {...this.props}
                            />
                          </div>
                        );
                      };

                      return (
                        <Grid
                          columnCount={columnCount}
                          rowCount={rowCount}
                          columnWidth={columnWidth}
                          rowHeight={cellHeight}
                          width={width}
                          height={height}
                          style={{
                            boxSizing: "border-box",
                          }}
                          cellRenderer={cellRenderer}
                        />
                      );
                    }}
                  </AutoSizer>
                </div>
                <div className="box">
                  {/* <div className="box__title">Site</div> */}

                  {/*<div className="box__body">
                    {this.state.lsusersatd.map((user, index) => (
                      <>
                        {(() => (
                          <CardUser
                            key={index}
                            user={user}
                            bind={this}
                            {...this.props}
                          />
                        ))()}
                      </>
                    ))}
                  </div>*/}
                </div>

                {/* <div className="box">
                                <div className="box__title">
                                  Site Ingenium System
                                </div>
                              </div> */}
              </div>
            </div>
            <div
              className="modal micromodal-slide"
              id="modal__bloqueio"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__bloqueio__title"
                >
                  <header className="modal__header">
                    <h2 className="modal__title" id="modal__bloqueio__title">
                      Bloqueio
                    </h2>

                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <div className="modal__header__bottom-line"></div>
                  <main
                    className="modal__content modal__content--small"
                    id="modal__bloqueio__content"
                  >
                    <div className="modal__content__user-details__content">
                      <form action="" className="modal__content__form">
                        <div className="modal__content__form__group modal__content__form__group--col-8">
                          <div className="modal__content--left">
                            <h3 className="modal-box__warning is-poppins">
                              Razão do bloqueio <br />
                            </h3>

                            <p className="modal-box__message">
                              Descreva a razão do bloqueio para o atendente
                            </p>
                          </div>

                          <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                          <div className="radio-content radio-content--column">
                            <div className="radio-button">
                              <input
                                type="radio"
                                id="block-atd"
                                name="block-atd"
                                onClick={(event) =>
                                  this.AlterBlockAction(event, "1")
                                }
                                defaultChecked={
                                  this.state.act === "1" ? true : false
                                }
                              />
                              <label htmlFor="block-atd">
                                <span>
                                  <div className="mask"></div>
                                </span>

                                <div className="text">Bloquear</div>
                              </label>
                            </div>
                            {(() => {
                              if (this.state.inable === false) {
                                return (
                                  <div className="radio-button">
                                    <input
                                      type="radio"
                                      id="logout-atd"
                                      name="logout-atd"
                                      onClick={(event) =>
                                        this.AlterBlockAction(event, "2")
                                      }
                                      defaultChecked={
                                        this.state.act === "2" ? true : false
                                      }
                                    />
                                    <label htmlFor="logout-atd">
                                      <span>
                                        <div className="mask"></div>
                                      </span>

                                      <div className="text">
                                        Logout do atendente
                                      </div>
                                    </label>
                                  </div>
                                );
                              }
                            })()}
                          </div>
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-8">
                          <div className="anotc-add__textarea">
                            <textarea
                              name="anotc-add__textarea__input"
                              id="anotc-add__textarea__input"
                              className="anotc-add__textarea__input"
                              value={this.state.textbloqueio}
                              onChange={(e) =>
                                this.setState({ textbloqueio: e.target.value })
                              }
                            ></textarea>
                          </div>
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                        <div className="modal__content__form__group modal__content__form__group--col-3">
                          <a
                            className="modal__content__form__group__button modal__content__form__group__button--white"
                            data-micromodal-close
                          >
                            Cancelar
                          </a>
                        </div>
                        <div className="modal__content__form__group modal__content__form__group--col-3">
                          {(() => {
                            if (this.state.inable === false) {
                              return (
                                <a
                                  className="modal__content__form__group__button "
                                  onClick={(event) =>
                                    this.ActionUserSup(event, "modal__bloqueio")
                                  }
                                >
                                  OK
                                </a>
                              );
                            } else {
                              return (
                                <a
                                  className="modal__content__form__group__button "
                                  onClick={(event) =>
                                    this.ActionBlockUserInable(
                                      event,
                                      "modal__bloqueio"
                                    )
                                  }
                                >
                                  OK
                                </a>
                              );
                            }
                          })()}
                        </div>
                      </form>
                    </div>
                  </main>
                </div>
              </div>
            </div>
            <div
              className="modal micromodal-slide"
              id="modal__desbloqueio"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__desbloqueio__title"
                >
                  <header className="modal__header">
                    <h2 className="modal__title" id="modal__desbloqueio__title">
                      Desbloqueio
                    </h2>

                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <div className="modal__header__bottom-line"></div>
                  <main
                    className="modal__content modal__content--small"
                    id="modal__desbloqueio__content"
                  >
                    <div className="modal__content__user-details__content">
                      <form action="" className="modal__content__form">
                        <div className="modal__content__form__group modal__content__form__group--col-8">
                          <div className="modal__content--left">
                            <h3 className="modal-box__warning is-poppins">
                              Razão do bloqueio <br />
                            </h3>

                            <p className="modal-box__message">
                              Descreva a razão do desbloqueio para o atendente
                            </p>
                          </div>

                          <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                          <div className="radio-content radio-content--column">
                            <div className="radio-button">
                              <input
                                type="radio"
                                id="radio-11"
                                name="radio-11"
                                onClick={(event) =>
                                  this.AlterBlockActionDesb(event, "1001")
                                }
                                defaultChecked={
                                  this.state.actdesb === "1001" ? "checked" : ""
                                }
                              />
                              <label htmlFor="radio-11">
                                <span>
                                  <div className="mask"></div>
                                </span>

                                <div className="text">Desbloquear</div>
                              </label>
                            </div>
                            {(() => {
                              if (this.state.inable === false) {
                                return (
                                  <div className="radio-button">
                                    <input
                                      type="radio"
                                      id="radio-22"
                                      name="radio-22"
                                      onClick={(event) =>
                                        this.AlterBlockActionDesb(event, "3")
                                      }
                                      defaultChecked={
                                        this.state.actdesb === "3"
                                          ? "checked"
                                          : ""
                                      }
                                    />
                                    <label htmlFor="radio-22">
                                      <span>
                                        <div className="mask"></div>
                                      </span>

                                      <div className="text">
                                        Logout do atendente
                                      </div>
                                    </label>
                                  </div>
                                );
                              }
                            })()}
                          </div>
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-8">
                          <div className="modal__content__form__group__desc">
                            {/* <div className="modal__content__form__group__desc__item">
                                              <strong>Bloqueado por:</strong>
                                              Gabriel Ferreira
                                            </div> */}
                            <div className="modal__content__form__group__desc__item">
                              <strong>Data de bloqueio:</strong>
                              {" " + this.state.duration}
                            </div>
                            <div className="modal__content__form__group__desc__item">
                              <strong>Hora de bloqueio:</strong>
                              {" " + this.state.horaaction}
                            </div>
                            <div className="modal__content__form__group__desc__item">
                              <strong>Razão do bloqueio:</strong>
                              <span>{" " + this.state.reasonaction}</span>
                            </div>
                          </div>
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-8">
                          <div className="anotc-add__textarea">
                            <textarea
                              name="anotc-add__textarea__input"
                              id="anotc-add__textarea__input-desb"
                              className="anotc-add__textarea__input"
                              value={this.state.textdesbloqueio}
                              onChange={(e) =>
                                this.setState({
                                  textdesbloqueio: e.target.value,
                                })
                              }
                            ></textarea>
                          </div>
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                        <div className="modal__content__form__group modal__content__form__group--col-3">
                          <a
                            className="modal__content__form__group__button modal__content__form__group__button--white"
                            data-micromodal-close
                          >
                            Cancelar
                          </a>
                        </div>
                        <div className="modal__content__form__group modal__content__form__group--col-3">
                          {(() => {
                            if (this.state.inable === false) {
                              return (
                                <a
                                  className="modal__content__form__group__button "
                                  onClick={(event) =>
                                    this.ActionUserSupDesbloq(event)
                                  }
                                >
                                  OK
                                </a>
                              );
                            } else {
                              return (
                                <a
                                  className="modal__content__form__group__button "
                                  onClick={(event) =>
                                    this.ActionUserSupDesbloqInable(event)
                                  }
                                >
                                  OK
                                </a>
                              );
                            }
                          })()}
                        </div>
                      </form>
                    </div>
                  </main>
                </div>
              </div>
            </div>
            <div
              className="modal micromodal-slide"
              id="modal__mensagem-equipe"
              aria-hidden="true"
              role="dialog"
            >
              <TeamModal showmodal={this.state.showmodal} />
            </div>
          </div>

          {/* {(() => {
            if (InfoUsers.supervisor === true) return <ManagerPerfomance />;
          })()} */}

          <Drawer
            filterApply={false}
            isOpen={this.state.openDrawer}
            setCloseDrawer={this.setVisibleDrawer}
            bind={this}
            filtersActive={this.state.totalFilters}
            cleanFilters={(e) => {
              this.RemoveAllGroup(e);
              this.RemoveAllState(e);
              this.setState({
                totalFilters: [],
              });
            }}
            title="Filtros"
            className="equipe-page"
          >
            <div className="field-select">
              <label htmlFor="mult-filter-inside">Grupos</label>
              <div
                className={
                  this.state.buttonfilter
                    ? "select card--no-mg active"
                    : "select card--no-mg"
                }
              >
                <button
                  className="select__btn"
                  type="button"
                  id="mult-filter-inside"
                  onClick={this.ShowFilters.bind(this)}
                >
                  {this.state.groupsSelec.length > 0 ? (
                    <div className="cards-preview">
                      {this.state.groupsSelec.map((gs, index) => (
                        <div className="card-preview" key={index}>
                          <div
                            className="card-preview__text"
                            onClick={(event) =>
                              this.RemoveGroupSelec(event, gs.id)
                            }
                          >
                            {gs.name}
                          </div>
                          <div className="card-preview__icon">
                            <i
                              onClick={(event) =>
                                this.RemoveGroupSelec(event, gs.id)
                              }
                              className="material-icons"
                            >
                              close
                            </i>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    "Grupos"
                  )}
                  <div className="cards-preview__select-icons">
                    {this.state.groupsSelec.length > 0 && (
                      <IconClose
                        onClick={(e) => {
                          e.stopPropagation();
                          this.RemoveAllGroup(e);
                        }}
                      />
                    )}
                    <i className="select__icon material-icons">
                      keyboard_arrow_right
                    </i>
                  </div>
                </button>
                <div className="options options--advanced">
                  <div className="options--advanced__search-box">
                    <div className="full-search">
                      <input
                        type="text"
                        name="client-search"
                        id="client-search"
                        placeholder="Busca..."
                        onChange={(event) => this.changeGroup(event)}
                      />
                      <button type="submit" className="full-search__btn">
                        <i className="material-icons">search</i>
                      </button>
                    </div>
                  </div>
                  <div className="options--advanced__filter-box">
                    <div className="options--advanced__filter-box__content">
                      {/* <!-- Grupos --> */}
                      {/* <div className="checkbox__list__title">Grupos</div> */}
                      <div className="checkbox checkbox__list">
                        {this.state.groups.map((group) => (
                          <li className="checkbox__item" key={group.id}>
                            <input
                              className="checkbox__list__input"
                              id={"checkbox-geral" + group.id}
                              name={"checkbox-geral" + group.id}
                              type="checkbox"
                              defaultChecked={
                                this.state.keyGen.findIndex(function (val) {
                                  return val === group.id;
                                }) !== -1
                                  ? true
                                  : false
                              }
                              onChange={(event) =>
                                this.filterGroup(event, group.id, group.name)
                              }
                              value="Geral"
                            />
                            <label htmlFor={"checkbox-geral" + group.id}>
                              {group.name}
                            </label>
                          </li>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="field-select">
              <label htmlFor="mult-filter-inside2">Status</label>
              <div
                className={
                  this.state.buttonfilter2 ? "select active" : "select "
                }
              >
                <button
                  id="mult-filter-inside2"
                  className="select__btn"
                  type="button"
                  data-pausa="Atendimento Presencial Cliente"
                  onClick={this.ShowFilters2.bind(this)}
                >
                  {this.state.keyGan.length > 0 ? (
                    <div className="cards-preview">
                      {this.state.keyGan
                        .filter(
                          (val) =>
                            val !== "ATOS" && val !== "CHND" && val !== "RV"
                        )
                        .map((value, index) => (
                          <div className="card-preview" key={index}>
                            <div
                              className="card-preview__text"
                              // onClick={(event) =>
                              //   this.RemoveGroupSelec(event, gs.id)
                              // }
                            >
                              {value === "LV" && "Livre"}
                              {value === "BQ" && "Pausado"}
                              {value === "BQSUPER" && "Bloqueado"}
                              {value === "AT" && "Em Interação"}
                              {value === "ACW" && "AfterCallWork"}
                              {value === "null" && "Inativo"}
                            </div>
                            <div className="card-preview__icon">
                              <i
                                onClick={(event) =>
                                  this.RemoveStateSelec(event, value)
                                }
                                className="material-icons"
                              >
                                close
                              </i>
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    "Status"
                  )}
                  <div className="cards-preview__select-icons">
                    {this.state.keyGan.length > 0 && (
                      <IconClose
                        onClick={(e) => {
                          e.stopPropagation();
                          this.RemoveAllState(e);
                        }}
                      />
                    )}
                    <i className="select__icon material-icons">
                      keyboard_arrow_right
                    </i>
                  </div>
                </button>
                <div className="options ">
                  {/* <!-- Status --> */}
                  <div className="options--advanced__filter-box">
                    <div className="options--advanced__filter-box__content">
                      {/* <div className="checkbox__list__title">Status</div> */}
                      <div className="checkbox checkbox__list">
                        <li className="checkbox__item">
                          <input
                            className="checkbox__list__input"
                            defaultChecked={
                              this.state.keyGan.findIndex(function (val) {
                                return val === "LV";
                              }) !== -1
                                ? true
                                : false
                            }
                            id="checkbox-LV"
                            name="checkbox-LV"
                            onChange={(event) => this.filterState(event, "LV")}
                            type="checkbox"
                          />
                          <label htmlFor="checkbox-LV">Livre</label>
                        </li>
                        <li className="checkbox__item">
                          <input
                            className="checkbox__list__input"
                            defaultChecked={
                              this.state.keyGan.findIndex(function (val) {
                                return val === "AT";
                              }) !== -1
                                ? true
                                : false
                            }
                            id="checkbox-AT"
                            type="checkbox"
                            onChange={(event) => this.filterState(event, "AT")}
                            value="Chamada ativa"
                          />
                          <label htmlFor="checkbox-AT">Em Interação</label>
                        </li>
                        <li className="checkbox__item">
                          <input
                            className="checkbox__list__input"
                            defaultChecked={
                              this.state.keyGan.findIndex(function (val) {
                                return val === "BQ";
                              }) !== -1
                                ? true
                                : false
                            }
                            id="checkbox-BQ"
                            type="checkbox"
                            onChange={(event) => this.filterState(event, "BQ")}
                            value="Pausado"
                          />
                          <label htmlFor="checkbox-BQ">Pausado</label>
                        </li>
                        <li className="checkbox__item">
                          <input
                            className="checkbox__list__input"
                            defaultChecked={
                              this.state.keyGan.findIndex(function (val) {
                                return val === "ACW";
                              }) !== -1
                                ? true
                                : false
                            }
                            id="checkbox-ACW"
                            type="checkbox"
                            onChange={(event) => this.filterState(event, "ACW")}
                            value="AfterCallWork"
                          />
                          <label htmlFor="checkbox-ACW">AfterCallWork</label>
                        </li>
                        <li className="checkbox__item">
                          <input
                            className="checkbox__list__input"
                            defaultChecked={
                              this.state.keyGan.findIndex(function (val) {
                                return val === "BQSUPER";
                              }) !== -1
                                ? true
                                : false
                            }
                            id="checkbox-BQSUPER"
                            type="checkbox"
                            onChange={(event) =>
                              this.filterState(event, "BQSUPER")
                            }
                            value="Bloqueado"
                          />
                          <label htmlFor="checkbox-BQSUPER">Bloqueado</label>
                        </li>
                        <li className="checkbox__item">
                          <input
                            className="checkbox__list__input"
                            id="checkbox-null"
                            type="checkbox"
                            defaultChecked={
                              this.state.keyGan.findIndex(function (val) {
                                return val === "null";
                              }) !== -1
                                ? true
                                : false
                            }
                            onChange={(event) =>
                              this.filterState(event, "null")
                            }
                            value="Inativo"
                          />
                          <label htmlFor="checkbox-null">Inativo</label>
                        </li>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </Drawer>
        </div>
        <div className="canvas__wrapper__footer">
          <div className="block transparent active-chats" id="active-chats">
            <div className="active-chats__tabs">
              <ul className="active-chats__list">
                <ChatSimultComponent
                  chatemcurso={this.state.chat}
                  remotescreen={"equipes"}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class CardUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      act: "1",
    };
  }

  typeOfPeriod(user) {
    if (
      (user.status_sip === "RV" && user.status === "LV") ||
      (user.status_sip === "LV" && user.status === "LV") ||
      user.status_sip === null ||
      user.status === null ||
      user.status_sip === "null" ||
      user.status === "null"
    ) {
      return "HL";
    } else if (
      (user.status_sip === "LV" && user.status === "AT") ||
      (user.status_sip === "AT" && user.status === "AT") ||
      (user.status_sip === "RV" && user.status === "ATOS") ||
      (user.status_sip === "AT" && user.status === "ATOS") ||
      (user.status_sip === "ATOS" && user.status === "AT") ||
      (user.status_sip === "LV" && user.status === "RV") ||
      (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND") ||
      user.status_sip === "QAT"
    ) {
      return "AT";
    } else if (user.status_sip === "BQ" && user.razao_bloqueio !== "") {
      return "HP";
    } else {
      return "ACW";
    }
  }

  shouldComponentUpdate(nextProps) {
    // Retorna true apenas se a prop user mudou
    return nextProps.user !== this.props.user;
  }

  render() {
    const {
      user,
      UserGroups,
      usersatd,
      ChatSimult,
      Messages,
      InfoUsers,
      MonitoringSimult,
      PermissionRouter,
      OutBandService,
      StatusAgent,
      listCallQueue,
      IPCurrent,
      bind,
    } = this.props;

    this.datalogin = Moment().format("DD/MM/YYYY");

    if (user.visible === true) {
      let classNameColor = "";
      let className = "card card--med card--med__expand";

      if (user.status_sip === "CHND" && user.razao_bloqueio != "CHND") {
        className = "card card--med card--med__expand card--calling card--blue";
      }

      if (user.superinfo) {
        className = "card card--med card--med__expand card--red card--calling";
      }

      if (user.status === "ACW" && user.status_sip === "ACW") {
        className = "card card--med card--med__expand card--red card--yellow";
      }

      if (
        (user.status_sip === "LV" && user.status === "AT") ||
        (user.status_sip === "AT" && user.status === "AT") ||
        (user.status_sip === "RV" && user.status === "ATOS") ||
        (user.status_sip === "AT" && user.status === "ATOS") ||
        (user.status_sip === "ATOS" && user.status === "AT") ||
        (user.status_sip === "LV" && user.status === "RV") ||
        (user.status_sip === "CHND" && user.razao_bloqueio != "CHND")
      ) {
        classNameColor = "card--chmd-ativa";
      } else if (user.status_sip === "QAT") {
        classNameColor = "card--chmd-consulta";
      } else if (
        (user.status_sip === "BQ" && user.razao_bloqueio != "") ||
        (user.status_sip === "BQSUPER" && user.status === "BQSUPER")
      ) {
        classNameColor = "card--pausado";
      } else if (user.status_sip === "ACW" && user.status === "ACW") {
        classNameColor = "card--after-call";
      } else if (
        user.status_sip === null ||
        user.status === null ||
        user.status_sip === "null" ||
        user.status === "null"
      ) {
        classNameColor = "card--inativo";
      } else if (
        (user.status_sip === "LV" && user.status === "LV") ||
        (user.status_sip === "RV" && user.status === "LV")
      ) {
        classNameColor = "card--livre";
      }

      return (
        <div className="card__wrapper">
          <div
            className={
              user.status_sip === "CHND" && user.razao_bloqueio != "CHND"
                ? "card card--box-med card--med__expand card--calling card--purple"
                : user.superinfo
                ? "card card--box-med card--med__expand card--red card--calling"
                : `card card--box-med card--med__expand ${classNameColor}`
            }
          >
            <div className="flex">
              <div className="card__content__status">
                {bind.renderIconInfo(user)}
                {user.status_sip === "BQ" && user.razao_bloqueio != "" && (
                  <Tooltippy content={user.razao_bloqueio}>
                    <div className="card__content__grupo">
                      <div className="card__content__grupo__item">
                        {user.razao_bloqueio}
                      </div>
                    </div>
                  </Tooltippy>
                )}
              </div>
              <div className="card__content">
                <div className="card__content-user_info">
                  <UserPhoto
                    size="large"
                    link={user.imgUser ? user.imgUser : false}
                  />
                  <div className="info">
                    <div className="card__content__title">
                      <div className="card__content__title__name-content">
                        <div className="text">{user.label}</div>
                        <Tooltippy
                          content={user.desc_grupo + " - " + user.ramal}
                        >
                          <div className="ramal">
                            <span className="group-name">
                              {user.desc_grupo}
                            </span>{" "}
                            - {user.ramal}
                          </div>
                        </Tooltippy>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="card__content__info">
                    {bind.renderNumbInfo(user)}
                    {user.dtl === "Received: INFO" || user.dtl === 0 ? (
                      ""
                    ) : (
                      <div className="card__content__info__item">
                        <HorasLogin />
                        {this.typeOfPeriod(user)}:{" "}
                        {parseInt(user.duration) === 0
                          ? null
                          : Moment(user.duration, "DD/MM/YYYY HH:mm:ss").format(
                              "HH:mm"
                            )}
                      </div>
                    )}
                    <div className="card__content__info__item">
                      <CalendarTeam />
                      {this.datalogin}
                    </div>
                    {bind.timeLastStatus(user, IPCurrent)}
                  </div>
                  {(() => {
                    if (parseInt(user.futurepause) === 1) {
                      return (
                        <div
                          key={
                            "futurepause" +
                            user.value +
                            "_" +
                            user.descfuturepause
                          }
                          className={"card__content__info__pausa"}
                        >
                          <div className="pausa__futura-btn__new-container">
                            <div className="pausa__futura-btn active">
                              <span className="pausa__futura-btn-dot"></span>
                              <FuturePauseIcon />
                            </div>
                            <Tooltippy
                              content={
                                user.descfuturepause ? user.descfuturepause : ""
                              }
                            >
                              <span className="pausa__futura-descricao ellipsis-hidden">
                                {user.countfpause} • {user.descfuturepause}
                              </span>
                            </Tooltippy>
                            {bind.timeFuturePause(user, IPCurrent)}
                          </div>
                        </div>
                      );
                    } else if (
                      user.countfpause !== undefined &&
                      parseInt(user.countfpause) > 0
                    ) {
                      return (
                        <div
                          key={
                            "futurepause" + user.value + "_" + user.countfpause
                          }
                          className={"card__content__info__pausa"}
                        >
                          <div className="pausa__futura-btn active">
                            <FuturePauseStatic />
                          </div>
                          <span className="pausa__futura-descricao">
                            {user.countfpause}
                          </span>
                        </div>
                      );
                    }
                  })()}
                </div>
              </div>
            </div>
            <div
              className={
                InfoUsers.supervisor === true
                  ? "monitorias"
                  : "monitorias monitorias--secondary"
              }
            >
              <Tooltippy content={"Enviar Mensagem"}>
                <a
                  href="#"
                  onClick={(event) => bind.InitialChat(event, ChatSimult, user)}
                  className="monitorias__item tippy-default"
                  data-tippy-placement="top"
                  data-tippy-content="Enviar mensagem"
                >
                  <EMCURSO />
                </a>
              </Tooltippy>

              {(() => {
                let containsOne = false;
                if (user && user.jsoncall) {
                  containsOne = user.jsoncall
                    .split("¿")
                    .some((part) => part.split("§").includes("1"));
                }

                if (InfoUsers.enablecallvoz) {
                  if (
                    (user.status === "AT" && parseInt(user.mediaid) === 1) ||
                    user.status === null ||
                    user.status_sip === null ||
                    user.status_sip === "null" ||
                    user.status === "null"
                  ) {
                    return (
                      <Tooltippy content={"Consulta"}>
                        <a
                          href="#"
                          className="monitorias__item tippy-default desabled"
                          data-tippy-placement="top"
                          data-tippy-content="Falar com atendente"
                        >
                          <Call />
                        </a>
                      </Tooltippy>
                    );
                  } else if (containsOne) {
                    return (
                      <Tooltippy content={"Consulta"}>
                        <a
                          href="#"
                          className="monitorias__item tippy-default desabled"
                          data-tippy-placement="top"
                          data-tippy-content="Falar com atendente"
                        >
                          <Call />
                        </a>
                      </Tooltippy>
                    );
                  } else {
                    // let checkAnswerInitial = getState().ChatSimult;
                    return (
                      <Tooltippy content={"Consulta"}>
                        <a
                          href="#"
                          onClick={(event) =>
                            bind.InitialCall(
                              event,
                              PermissionRouter,
                              1,
                              OutBandService,
                              InfoUsers,
                              StatusAgent.status,
                              listCallQueue,
                              user.ramal,
                              IPCurrent,
                              ChatSimult,
                              user
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Falar com atendente"
                        >
                          <Call />
                        </a>
                      </Tooltippy>
                    );
                  }
                }
              })()}

              {(() => {
                if (InfoUsers.supervisor === true)
                  return (
                    <>
                      <Tooltippy content={"Escuta Sigilosa"}>
                        <a
                          href="#"
                          onClick={(e) =>
                            bind.InitialMonitoring(
                              e,
                              InfoUsers.id,
                              user.iduser,
                              user.label,
                              MonitoringSimult,
                              "1",
                              user.ramal
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Escuta sigilosa"
                        >
                          <SIGILOSA />
                        </a>
                      </Tooltippy>
                      <Tooltippy content={"Sussurro"}>
                        <a
                          href="#"
                          onClick={(e) =>
                            bind.InitialMonitoring(
                              e,
                              InfoUsers.id,
                              user.iduser,
                              user.label,
                              MonitoringSimult,
                              "2",
                              user.ramal
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Sussurro"
                        >
                          <SUSSURRO />
                        </a>
                      </Tooltippy>
                      <Tooltippy content={"Intercalar"}>
                        <a
                          href="#"
                          onClick={(e) =>
                            bind.InitialMonitoring(
                              e,
                              InfoUsers.id,
                              user.iduser,
                              user.label,
                              MonitoringSimult,
                              "3",
                              user.ramal
                            )
                          }
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Intercalar"
                        >
                          <INTERCALAR />
                        </a>
                      </Tooltippy>
                      <Tooltippy content={"Bloquear"}>
                        <a
                          onClick={(event) =>
                            bind.showModal(
                              event,
                              user.iduser,
                              user.status_sip,
                              user.razao_bloqueio,
                              user.duration,
                              user.status
                            )
                          }
                          href="#"
                          className="monitorias__item tippy-default"
                          data-tippy-placement="top"
                          data-tippy-content="Bloqueio"
                        >
                          <BLOQUEIO />
                        </a>
                      </Tooltippy>
                    </>
                  );
              })()}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InternalManager);
